import './polyfill'

import domready from 'domready'
import appUpdatedPrompt from 'src/appUpdatedPrompt'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { I18nextProvider } from 'react-i18next'

import i18next from 'src/i18n'

import AppContainer from 'src/AppContainer'
import { NonSPAStoreProvider } from 'src/AppContainer/Store'
import { BreadcrumbsProvider } from './src/AppContainer/BreadcrumbsProvider'
import '../styles/main.less'

const module = document.body.dataset.main

let dynamicImport
switch (module) {
    case null:
    case '':
        break
    case 'AutomotiveMakes':
        dynamicImport = import('src/AutomotiveModelsBundle/Resources/js/automotive-makes')
        break
    case 'AutomotiveModels':
        dynamicImport = import('src/AutomotiveModelsBundle/Resources/js/automotive-models')
        break
    case 'ManagementUsersIndex':
        dynamicImport = import('src/ManagementUserBundle/Resources/js/index')
        break
    case 'CampaignFeedback':
        dynamicImport = import('src/CampaignFeedbackBundle/Resources/js/index')
        break
    case 'Previews':
        dynamicImport = import('src/EventWebsitePreviewBundle/Resources/js/index')
        break
    case 'ReferralsView':
        dynamicImport = import('src/ReferralBundle/Resources/js/index')
        break
    case 'SurveyView':
        dynamicImport = import('src/SurveyCampaignBundle/Resources/js/index')
        break
    case 'RewardsView':
        dynamicImport = import('src/TangoRewardsBundle/Resources/js/index')
        break
    case 'CampaignClientUsersPermissions':
        dynamicImport = import('src/CampaignBundle/Resources/js/client_users_permissions')
        break
    case 'ManagementUserEdit':
        dynamicImport = import('src/ManagementUserBundle/Resources/js/edit')
        break
    case 'ManagementUserNew':
        dynamicImport = import('src/ManagementUserBundle/Resources/js/new')
        break
    case 'ServiceAgreementSigning':
        dynamicImport = import('src/ServiceAgreementBundle/Resources/js/service-agreement-singing')
        break
    case 'ServiceAgreementPaymentInformation':
        dynamicImport = import('src/ServiceAgreementBundle/Resources/js/payment-information')
        break
    case 'ServiceAgreementEnhancementApproval':
        dynamicImport = import('src/ServiceAgreementBundle/Resources/js/enhancement-approval')
        break
    case 'UserActivate':
        dynamicImport = import('src/UserBundle/Resources/js/activate__view')
        break
    case 'UserLogin':
        dynamicImport = import('src/UserBundle/Resources/js/login')
        break
    case 'UserPasswordReset':
        dynamicImport = import('src/UserBundle/Resources/js/reset__view')
        break
    case 'UserPasswordForgot':
        dynamicImport = import('src/UserBundle/Resources/js/forgot__view')
        break
    case 'UserProfile':
        dynamicImport = import('src/ProfileBundle/Resources/js/profile')
        break
    case 'UIShowcaseBadges':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/badges')
        break
    case 'UIShowcaseUIRefresh':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/uirefresh')
        break
    case 'UIShowcaseDateTimeForm':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/date_time_form')
        break
    case 'UIShowcaseForm':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/form')
        break
    case 'UIShowcaseFormWithProgress':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/form-with-progress')
        break
    case 'UIShowcaseMessages':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/messages')
        break
    case 'UIShowcaseTabs':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/tabs')
        break
    case 'UIShowcaseTags':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/tags')
        break
    case 'UIShowcaseToasts':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/toasts')
        break
    case 'UIShowcaseDialogs':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/dialogs')
        break
    case 'UIShowcaseModals':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/modals')
        break
    case 'UIShowcasePopover':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/popover')
        break
    case 'UIShowcaseTiles':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/tiles')
        break
    case 'UIShowcaseButtons':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/buttons')
        break
    case 'UIShowcaseListView':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/list-view')
        break
    case 'UIShowcaseDataGrid':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/data-grid')
        break
    case 'UIShowcaseDatePicker':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/date-picker')
        break
    case 'UIShowcaseTabsReact':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/tabs-react')
        break
    case 'UIShowcaseStatsBox':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/stat-box')
        break
    case 'UIShowcaseSheet':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/sheet')
        break
    case 'UIShowcaseStarRating':
        dynamicImport = import('src/UIShowcaseBundle/Resources/js/star-rating')
        break
    case 'NotificationPreviewEmail':
        dynamicImport = import('src/NotificationPreviewBundle/Resources/js/NotificationPreviewEmail')
        break
    case 'NotificationsPreview':
        dynamicImport = import('src/NotificationPreviewBundle/Resources/js/NotificationsPreviewList')
        break
    case 'ProspectUnsubscribe':
        dynamicImport = import('src/ProspectUnsubscribeBundle/Resources/js/main')
        break
    case 'ProspectsMergeFields':
        dynamicImport = import('src/ProspectBundle/Resources/js/merge-fields')
        break
    case 'NotificationPreview':
        dynamicImport = import('src/NotificationPreviewBundle/Resources/js/NotificationPreviewEmail/index')
        break
    case 'AuditLog':
        dynamicImport = import('src/AuditLogBundle/Resources/js/index')
        break
    default:
        console.error(`No module found with name ${module}`)
}

if (dynamicImport) {
    dynamicImport.then(m => {
        domready(m.default)
    })

    domready(function () {
        if (document.getElementsByClassName('js-header-react').length > 0) {
            const element = document.createElement('div')
            element.id = 'app-container-root'
            element.style.display = 'none'
            document.body.prepend(element)

            createRoot(element).render((
                <I18nextProvider i18n={i18next}>
                    <BrowserRouter>
                        <NonSPAStoreProvider>
                            <BreadcrumbsProvider>
                                <AppContainer/>
                            </BreadcrumbsProvider>
                        </NonSPAStoreProvider>
                    </BrowserRouter>
                </I18nextProvider>
            ))
        }
    })

    appUpdatedPrompt()
}
